import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getHomePageTinyAccountId } from 'store/home';
import { getLatestNonVoidKitForTinyAccountId } from 'store/kits';

import { usePortalConfigs, UsePortalConfigsResult } from './usePortalConfigs';

/**
 * Portal config of the profile selected on Home, resolved from that profile's
 * latest non-void kit. Shared by every place that must agree on whether
 * upsells are allowed for the profile being viewed (e.g. the "Buy a kit" card
 * and the `/purchase-kit` route guard).
 *
 * With no selected profile (the `home` slice is not persisted, so this
 * happens after a reload outside Home) it falls back to the aggregate config
 * across all kits, so accounts that hide upsells are never let through.
 */
export const useSelectedProfilePortalConfig = (): UsePortalConfigsResult => {
  const tinyAccountId = useSelector(getHomePageTinyAccountId);
  const latestKitSelector = useMemo(
    () => getLatestNonVoidKitForTinyAccountId(tinyAccountId),
    [tinyAccountId],
  );
  const latestKit = useSelector(latestKitSelector);

  return usePortalConfigs(tinyAccountId ? latestKit : undefined);
};
